import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import parse from 'html-react-parser'

import Image from "next/image"

import { 
    QuerySEO,
	QueryPartners,
} from "../../graphql/queries"

import { FooterShim } from "../../fuselage/global/footer/footer"

import { OffsiteLink } from '../../fuselage/components/offsite-link/offsite-link'
import { StickySidebar } from '../../fuselage/layout/sticky-sidebar/sticky-sidebar'
import { ArrowLink } from '../../fuselage/components/arrow-link/arrow-link'

import CSS from '../../css/app/partners.module.css'

function Partner({ partner }) {

	// console.log('partner:', partner)


	const handleWebsite = () => {
		if( partner.website ) {
			return (
				<OffsiteLink href={partner.website} direction='right' target='_blank'>
					Learn more
				</OffsiteLink>
			)
		}
	}

	return (

		<>

			<section className="block pt-0">
				<div className="container">

					<StickySidebar size='medium'>
						
						<aside className="formatted">
							<p className="fw-600"><ArrowLink href="/ahif-sponsors">View all partners</ArrowLink></p>

							<div className={CSS.profileLogo}>
								{
									partner.partnerLogo.length &&
									<div className={CSS.profileLogoWrapper}>
										<Image 
											src={partner.partnerLogo[0].url} 
											layout='fill'
											alt=""
										/>
									</div>
								}
							</div>
						</aside>
						
						<main className="maxw-60">

							{/* <p className='fs-2 fw-600 lh-1 c-secondary maxw-40'>partner.level</p> */}
							<p className="fs-3 fw-600 caps mt-sm">{ partner.title }</p>	
							{
								partner.partnerProfile &&
								<div className="mt-sm maxw-50" style={{ whiteSpace: `pre-line` }}>{ parse(String(partner.partnerProfile)) }</div>
							}
							<p className="mt-md fw-600">{ handleWebsite() }</p>
						</main>

					</StickySidebar>

				</div>
			</section>

		</>
	)
}






export async function getStaticPaths() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", id: 177588) {
					title
					... on ${process.env.SITE_HANDLE}Pages_page_Entry {
						id
						title
						slug
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryPartners}
						}
					}
					${QuerySEO}
				}
			}
        `
    })
	
	// get partner page content-blocks	
	let blocks = cmsData.data.entry.ahifContentBlocks

	// find partner-group content-blocks
	let groupData = blocks.find( group => group.__typename === "ahifContentBlocks_partnerGroups_BlockType")

	// search each group for individual partner slugs
	let slugs = []
	groupData?.partnerGroups.forEach( group => group.partners.forEach( partner => slugs.push(partner.slug)) )

	return {
		paths: slugs.map( slug => ({ params: { slug: slug } })),
		fallback: false
	}
}

export async function getStaticProps({ params }) {

	// console.log('params',params)
	
	const partner = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", slug: "${params.slug}" ) {
					... on partners_partner_Entry {
						id
						slug
						title
						website
						partnerProfile
						partnerLogo {
							id
							url
							width
							height
						}
					}
				}
			}
        `
    })

	return {
		props: { partner: partner.data.entry }
	}
}

export default Partner


